export const CreateGroupModalText = {
    InputPlaceholder: "New Lens Group name",
    Action: "Create New Lens Group",
};
